/* eslint-disable react/require-default-props */
import React from 'react';
import { Modal } from 'react-bootstrap';
import AiManagementModalHeader from 'components/molecules/ai_management_modal_header';
import { Container } from './styles';

interface AiManagementConfirmModalProps {
  show: boolean;
  title: string;
  children: React.ReactNode;
  confirmLabel: string;
  savingLabel?: string;
  variant?: 'primary' | 'danger';
  saving?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const AiManagementConfirmModal: React.FC<AiManagementConfirmModalProps> = ({
  show,
  title,
  children,
  confirmLabel,
  savingLabel,
  variant = 'primary',
  saving = false,
  onClose,
  onConfirm,
}) => (
  <Modal show={show} onHide={saving ? undefined : onClose} centered>
    <Container>
      <AiManagementModalHeader title={title} onClose={onClose} />

      <div className="confirm-body p-4">{children}</div>

      <div className="d-flex justify-content-end border-top px-4 py-3">
        <button
          type="button"
          className="btn btn-outline-secondary mr-2"
          onClick={onClose}
          disabled={saving}
        >
          Cancelar
        </button>
        <button
          type="button"
          className={`btn btn-${variant} px-4`}
          onClick={onConfirm}
          disabled={saving}
        >
          {saving && savingLabel ? savingLabel : confirmLabel}
        </button>
      </div>
    </Container>
  </Modal>
);

export default AiManagementConfirmModal;
